import { Action } from '@agile-actors/actions/js';

const namespaceAction = Action('@@UI/HEADER');

const toggle = namespaceAction('TOGGLE');
const setTransparent = namespaceAction('SET_TRANSPARENT');

export { toggle, setTransparent };
